import React, { useEffect } from 'react';
import { useSelector, useDispatch } from 'react-redux';

import Header from '../../components/Header';
import Title from '../../components/Title';
import Text from '../../components/Text';
import Line from '../../components/Line';
import Actions from '../../components/Actions';
import MobileMenuHeader from '../../components/MobileMenuHeader';
import CostRevenueCard from './CostRevenueCard';
import UploadFinancialFiles from '../../components/UploadFinancialFiles';

export default function Summary(props) {
  const {
    nextClickHandler,
    menuItems,
    selectComponent,
    componentIndex,
    rules,
    backPath,
    locales,
    locales: {
      common,
      tipCustomerSegment,
      costRevenue: {
        name,
        summary: { header, title, text, fileUpload },
        intro: { costCard, revenueCard },
      },
    },
  } = props;
  const { cost, product, revenue } = useSelector((state) => state);
  const {
    bmc: {
      current: { id: bmcId },
    },
    financialFile: { collection },
  } = useSelector((state) => state);

  const {
    financialFile: { fetchFinancialFiles },
  } = useDispatch();

  useEffect(() => {
    if (bmcId && collection.length === 0) {
      fetchFinancialFiles(bmcId);
    }
  }, [bmcId, collection.length]);

  return (
    <section className="bmc-page" aria-label={header}>
      <Header
        title={header}
        subtitle={name}
        icon="icon-cost"
        locales={locales}
        componentIndex={componentIndex}
        className="bmc-page-header--violet"
        tipLocales={tipCustomerSegment}
        menuItems={menuItems}
        onMenuItemClick={selectComponent}
        rules={rules}
        backPath={backPath}
        mobileMenuHeader={
          <MobileMenuHeader icon="FinanceCanvas" title={name} color="violet" />
        }
      />

      <Text>{[text[0]]}</Text>

      <Line />

      <Title text={title[2]} className="margin-top-60" />

      <CostRevenueCard
        card={{
          ...costCard,
          ...revenueCard,
          title: false,
          projectSales: locales.costRevenue.projectedSales.title,
          costs: cost.collection,
          products: product.collection,
          revenues: revenue.collection,
          portfolio: locales.portfolio,
        }}
        className="margin-top-60 margin-wide-40-lg"
        locales={locales}
        forecast
        chart
      />

      {/* <Line className="margin-top-60" /> */}

      <Title text={fileUpload.title} className="margin-top-60" />

      {fileUpload.description}

      <div className="margin-top-30 margin-wide-40-lg bmc-page-fincard-body">
        <UploadFinancialFiles
          locales={locales}
          className="margin-top-40"
          // fileTextColor={styleColor}
          // fileBorderColor={styleColor}
          uplouderButtonStyle="portfolio-file-uploader__current"
          fileStyle="portfolio-file-uploader-file__title"
          // borderButtonColor={styleColor}
          // textButtonColor={styleColor}
        />
      </div>

      <Actions nextClickHandler={nextClickHandler} buttonName={common.done} />
    </section>
  );
}
